// extracted by mini-css-extract-plugin
export default {"spacer-16":"src-components-atoms-spacer-16-spacer-16-module__spacer-16--CZas2","spacer16":"src-components-atoms-spacer-16-spacer-16-module__spacer-16--CZas2"};